import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SigninWithNaver, SigninWithKakao } from "../apis/Users.js";
import Signup from "./Signup";
import { clearGuestAccess } from "../utils/guestAccess";

function NaverCallback() {
  const navigate = useNavigate();
  const called = useRef(false);
  const [token, setToken] = useState(null);
  
  useEffect(() => {
    if (called.current) return;
    called.current = true;
    const code = new URL(window.location.href).searchParams.get("code");

    SigninWithNaver(code).then(async (response) => {
      const data = await response.json();
      if (response.ok) {
        clearGuestAccess();
        navigate('/');
      } else if (response.status === "deleted") {
        alert("탈퇴 처리된 계정입니다.");
        navigate('/pages/signin');
      } else if (response.status === "not_found") {
        setToken(data.temp_token);
      } else {
        console.log('Naver Signin failed');
      }
    });
  }, [navigate]);

  if (token) {
    return <Signup providerOverride="naver" tokenOverride={token} />;
  }

  return null;
}

function KakaoCallback() {
  const navigate = useNavigate();
  const called = useRef(false);
  const [token, setToken] = useState(null);
  
  useEffect(() => {
    if (called.current) return;
    called.current = true;
    const code = new URL(window.location.href).searchParams.get("code");
    
    SigninWithKakao(code).then(async (response) => {
      const data = await response.json();
      if (data.ok) {
        clearGuestAccess();
        navigate('/');
      } else if (data.status === "deleted") {
        alert("탈퇴 처리된 계정입니다.");
        navigate('/pages/signin');
      } else if (data.status === "not_found") {
        setToken(data.temp_token);
      } else {
        console.log('Kakao Signin failed');
      }
    });
  }, [navigate]);

  if (token) {
    return <Signup providerOverride="kakao" tokenOverride={token} />;
  }

  return null;
}

export { NaverCallback, KakaoCallback };
